import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppBrowserModule, setupRuntimeConfig } from './app/app.browser.module';
import { environment } from './environments/environment';

console.log('Environment configuration:', environment);

if (environment.PRODUCTION) {
  enableProdMode();
}

setupRuntimeConfig.then(() => {
  platformBrowser()
    .bootstrapModule(AppBrowserModule)
    .catch((err) => console.error(err));
});

